const country = {
  country: "Land",
  name: "Name",
  schoolYearType: "Schuljahrestyp",
  defaultLanguage: "Standardsprache",
  currency: "Währung",
  subscriptionPrice: "Abonnementpreis",
  saveCountryQuestion: "Dieses Land speichern?",
  saveCountryDescription:
    "Achtung: Die Änderung der Währung oder des Abonnementpreises gilt nur für neue Abonnements oder Verlängerungen.",
  countryDetail: "Länderdetails",
  countryCreation: "Land erstellen",
  countries: "Länder",
};

export default country;
